import { useAuth } from '@acast-tech/auth-client';
import { useUserNetworksQuery } from '@/services/userApiQueries';

/**
 * Returns true if any of the user's insights networks contain
 * at least one show with hls_enabled set to true.
 */
const useHasHlsEnabledNetwork = (): boolean => {
  const { userId, isImpersonating } = useAuth();
  const { data: allNetworks } = useUserNetworksQuery(userId, isImpersonating);

  return (
    allNetworks?.insights?.some((network) =>
      network.shows.some((show) => show.hls_enabled),
    ) ?? false
  );
};

export default useHasHlsEnabledNetwork;
